import React from 'react';

const UpdateButton = ({ onClick }) => (
  <button onClick={onClick} className="meta-update ml-2">Update</button>
);

export default UpdateButton;